import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { Child, Variant } from "src/app/pages/users/q-commerce/models/category-group.model";
import { ServicesService } from "src/app/pages/users/service/services/services.service";

@Component({
  selector: "app-clear-cart-modal",
  imports: [CommonModule, TranslateModule],
  templateUrl: "./clear-cart-modal.component.html",
  styleUrl: "./clear-cart-modal.component.scss"
})
export class ClearCartModalComponent {
  selectedProduct!: Child;
  selectedVariant!: Variant;
  clearCartModalRef!: NgbModalRef;
  @Output() onModalClosed = new EventEmitter<{ product: Child; variant?: Variant }>();
  @ViewChild("clearCartModal", { static: true }) clearCartModal!: TemplateRef<any>;
  config: NgbModalOptions = { size: "sm", centered: true, backdrop: "static" };

  constructor(private modalService: NgbModal, private servicesService: ServicesService) {}

  openModal(product: Child, variant?: Variant): void {
    this.clearCartModalRef = this.modalService.open(this.clearCartModal, { ...this.config });
    this.selectedProduct = product;
    if (variant) {
      this.selectedVariant = variant;
    }
  }

  closeModal(): void {
    this.clearCartModalRef.close();
  }

  clearCart(): void {
    localStorage.removeItem("serviceCartItems");
    localStorage.removeItem("cartServiceItemMainCategory");
    this.servicesService.updateCartItems([]);
    this.closeModal();
    this.onModalClosed.emit({
      product: this.selectedProduct,
      variant: this.selectedVariant
    });
  }
}
